<template>
  <el-dialog
    class="snooker-room-dialog"
    :title="`球桌管理${parentData?'-'+parentData.name+'('+parentData.campusName +')':''}`"
    :visible.sync="show"
    :close-on-click-modal="false"
    :before-close="closed"
    width="1100px"
  >
    <div class="flex mb-1" v-permission="['snooker:room:edit']" style="text-align: right">
      <div class="tip " style="margin: 0;">
        注意事项：桌球室需配置球桌后方可生成排期计划。
      </div>
      <div class="flex-1">
        <el-button :disabled="isEditing"
                   type="warning"
                   plain
                   size="mini" @click="batchDisable">
          批量禁用球桌
        </el-button>
        <el-button icon="el-icon-plus" type="primary"
                   plain
                   size="mini" @click="newRow">
          增加球桌
        </el-button>
      </div>
    </div>
    <el-form ref="formRef" :model="formData" v-loading="loadData.loading" :rules="rules" style="padding-right: 0;">
      <el-table ref="tableRef" :data="formData.tableData"
                @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40" />
        <el-table-column label="ID" type="index" width="50px" align="center" />
        <el-table-column label="球桌编号" min-width="160px">
          <template v-slot="scope">
            <el-form-item
              v-if="scope.row.isEditing"
              :prop="`tableData.${scope.$index}.tableNo`"
              :rules="rules.tableNo">
              <el-input size="small" class="flex-1" v-model.trim="scope.row.tableNo" placeholder="请输入球桌编号" />
            </el-form-item>
            <span v-else>{{ scope.row.tableNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="球桌名" min-width="160px">
          <template v-slot="scope">
            <el-form-item
              v-if="scope.row.isEditing"
              :prop="`tableData.${scope.$index}.tableName`"
              :rules="rules.tableName">
              <el-input size="small" class="flex-1" v-model.trim="scope.row.tableName" placeholder="请输入球桌名" />
            </el-form-item>
            <span v-else>{{ scope.row.tableName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="启用状态" width="120px" align="center">
          <template v-slot="scope">
            <el-form-item v-if="scope.row.isEditing">
              <el-switch
                class="ml-1"
                v-model="scope.row.enable"
                active-color="var(--color-success)"
                :active-value="1"
                :inactive-value="0"
                :style="{'--text':scope.row.enable? '启用' : '禁用'}"
              />
            </el-form-item>
            <el-tag :type="+scope.row.enable?'success':'info'"
                    v-else>
              {{ +scope.row.enable ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="220px">
          <template v-slot="scope">
            <el-form-item v-if="scope.row.isEditing" :prop="`tableData.${scope.$index}.remarks`">
              <el-input size="small" v-model="scope.row.remarks" maxlength="200" />
            </el-form-item>
            <span v-else>{{ scope.row.remarks }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160px">
          <template v-slot="scope">
            <template v-if="scope.row.isEditing">
              <el-form-item>
                <el-button size="small" @click="cancelEdit(scope)">取消</el-button>
                <el-button v-permission="['snooker:room:edit']"
                           type="primary" size="small"
                           v-if="scope.row.isEditing" @click="save(scope)">保存
                </el-button>
              </el-form-item>
            </template>
            <template v-else>
              <template v-if="!isEditing">
                <el-button size="mini"
                           type="danger"
                           @click="del(delSnookerTableApi, scope.row.id,`球桌-${scope.row.tableNo}`)">
                  删除
                </el-button>
                <el-button v-role="['开发人员']" size="mini"
                           type="primary" plain
                           @click="editRow(scope)">编辑
                </el-button>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <template #footer>
      <el-button @click="closed">关闭</el-button>

    </template>
  </el-dialog>
</template>

<script>
import dialog from '@/vue/mixins/dialog'
import tableView from '@/vue/mixins/table-view'
import Vue from 'vue'
import {
  batchDisableSnookerTableApi,
  delSnookerTableApi,
  listSnookerTableApi,
  saveSnookerTableApi
} from '@/api/student-manage/snooker-table-api'

export default {
  name: 'SnookerTableDialog',
  mixins: [dialog, tableView],
  props: {},
  data() {
    return {
      isEditing: false,
      rowCheckList: [],
      parentData: {},
      formData: {
        tableData: []
      },
      rules: {
        tableNo: [{
          required: true,
          message: '请输入球桌编号',
          trigger: 'blur'
        },
          this.$store.state.commonValidate.limit20WordsObj],
        tableName: [this.$store.state.commonValidate.limit30WordsObj]
      }
    }
  },
  mounted() {
    this.$nextTick(async () => {
      await this.renderTable()
    })
  },
  methods: {
    delSnookerTableApi,
    async renderTable() {
      this.loading = true
      try {
        const res = await listSnookerTableApi({ snookerRoomId: this.parentData.id })
        this.formData.tableData = res.data
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    newRow() {
      if (this.isEditing) {
        this.$message('请先保存已修改的数据，再进行新增操作！')
      } else {
        const _row = {
          id: null,
          snookerRoomId: this.parentData.id,
          tableNo: '',
          tableName: '',
          remarks: '',
          enable: 1,
          isEditing: true
        }
        this.formData.tableData.unshift(_row)
        this.isEditing = true
      }
    },
    async cancelEdit(scope) {
      scope.row.isEditing = false
      this.isEditing = false
      Vue.set(this.formData.tableData, scope.$index, scope.row)
      await this.renderTable()
    },
    editRow(scope) {
      this.isEditing = true
      scope.row.isEditing = true
      Vue.set(this.formData.tableData, scope.$index, scope.row)
    },
    // 多选
    handleSelectionChange(list) {
      this.rowCheckList = list
    },
    // 批量禁用
    batchDisable(scope) {
      this.$confirm(`是否确认批量禁用选中的${this.rowCheckList.length}张球桌？`, '批量禁用').then(async () => {
        try {
          const _rowIds = this.rowCheckList.map(item => item.id)
          await batchDisableSnookerTableApi({ snookerRoomTableIds: _rowIds })
          await this.renderTable()
        } catch (e) {
          console.error(e)
        }
      })
    },
    save(scope) {
      const _duplicateKeys = this.formData.tableData.filter(({ tableNo }) => tableNo === scope.row.tableNo)
      if (_duplicateKeys.length > 1) {
        this.$message.error('已存在相同台球桌编号！')
        return
      }
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.$confirm('点击确定保存台球桌。', '保存').then(async () => {
            try {
              await saveSnookerTableApi(scope.row)
            } catch (e) {
            }
          }).catch(() => {
            this.cancel(scope)
          }).finally(() => {
            this.renderTable()
            this.isEditing = false
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.snooker-room-dialog {
  .el-dialog__body{
    padding-top: 0;
  }
  .table-item {
    align-items: center;

    .el-switch {
      &:before {
        content: attr(--text);
      }
    }
  }
}
</style>
